import { connect } from 'react-redux';

import { uncurlyUuid } from 'src/components/analytics';
import {
  requestDecline,
  closeDialog,
  getIsDeclineRequesting,
  getIsDeclineErrored,
  getDeclineErrorMessage,
} from 'src/redux/pull-request/decline-reducer';
import { getIRAnalyticsTrackingAttributes } from 'src/redux/pull-request/selectors';
import {
  getCurrentRepositoryUuid,
  getCurrentRepositoryWorkspaceUUID,
} from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import DeclineDialog from '../components/decline-dialog/decline-dialog';

const mapStateToProps = (state: BucketState) => {
  const repositoryUuid = getCurrentRepositoryUuid(state);
  const workspaceUuid = getCurrentRepositoryWorkspaceUUID(state);

  return {
    isRequesting: getIsDeclineRequesting(state),
    isErrored: getIsDeclineErrored(state),
    errorMessage: getDeclineErrorMessage(state),
    repositoryUuid: repositoryUuid ? uncurlyUuid(repositoryUuid) : '',
    workspaceUuid: workspaceUuid ? uncurlyUuid(workspaceUuid) : '',
    // will be passed along to analytics event (`button clicked declineButton`)
    irTracking: getIRAnalyticsTrackingAttributes(state),
  };
};

const mapDispatchToProps = {
  declinePullRequest: requestDecline,
  onClose: closeDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeclineDialog);
